// src/components/Navbar.js

import React, { useRef, useState, useEffect, useContext } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from 'react-router-dom';
import "../styles/Navbar.css";
import { AuthContext } from '../AuthContext';
import api from '../api';

const Navbar = ({ onLogout }) => {
  const navRef = useRef(null);
  const { token, isAuthenticated } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (!isAuthenticated || !token) {
      setIsAdmin(false);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/auth/me');
        if (!cancelled) {
          setIsAdmin(Boolean(res.data?.is_superuser));
        }
      } catch {
        if (!cancelled) setIsAdmin(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, token]);

  // Function to toggle the mobile menu
  const showNavbar = () => {
    navRef.current?.classList.toggle("responsive_nav");
    setDropdownOpen(false);
  };

  // Function to close the mobile menu
  const closeNavbar = () => {
    navRef.current?.classList.remove("responsive_nav");
    setDropdownOpen(false);
  };

  const toggleDropdown = (event) => {
    event.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header className="app-header">
      <div className="navbar-container">
        <h3>TGTS Budget System</h3>

        <nav ref={navRef}>
          <Link to="/" onClick={showNavbar}>Home</Link>
          <Link to="/income" onClick={showNavbar}>Income</Link>
          <Link to="/bills" onClick={showNavbar}>Bills</Link>
          <Link to="/payments" onClick={showNavbar}>Payments</Link>
          <Link to="/debts" onClick={showNavbar}>Debts</Link>
          <Link to="/expenses" onClick={showNavbar}>Expenses</Link>
          <Link to="/creditcards" onClick={showNavbar}>Credit Cards</Link>

          <div className={`dropdown ${dropdownOpen ? 'active' : ''}`}>
            <button className="dropbtn" onClick={toggleDropdown}>
              Miscellaneous
            </button>
            <div className="dropdown-content">
              <Link to="/accounts" onClick={closeNavbar}>Accounts</Link>
              <Link to="/categories" onClick={closeNavbar}>Categories</Link>
              {isAdmin && (
                <Link to="/users" onClick={closeNavbar}>Users</Link>
              )}
              <Link to="/settings" onClick={closeNavbar}>Settings</Link>
            </div>
          </div>

          <button onClick={onLogout} className="logout-button">
            Log out
          </button>

          <button className="nav-btn nav-close-btn" onClick={showNavbar}>
            <FaTimes />
          </button>
        </nav>

        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
